import { readTable } from "./TablePreview";
import { tableWidth } from "@/components/editor/table-grid/tableCells";
import type { TableSummary } from "./useTables";

/**
 * The words the tables surfaces share, so the sheet, the cards and the tool
 * say the same thing the same way (Olivia, tables-modern).
 */

/** "just now", "20 min ago", "2 h ago", "yesterday", "3 days ago", "12 Sept". */
export function editedAgo(iso: string | undefined, now = Date.now()): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const m = Math.round((now - then) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  if (d === 1) return "yesterday";
  if (d < 7) return `${d} days ago`;
  if (d < 14) return "last week";
  return new Date(then).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

/** "In 4 papers", "In 1 paper", "Not in a paper". */
export function inPapers(n: number): string {
  if (n <= 0) return "Not in a paper";
  return `In ${n} paper${n === 1 ? "" : "s"}`;
}

/** "9 × 6": columns × rows, as the tool's grid pane says it. */
export function tableSize(t: Pick<TableSummary, "content">): string {
  const data = readTable(t.content);
  return data ? `${tableWidth(data.header, data.rows, data.hasHeader)} × ${data.rows.length}` : "";
}

export const tableName = (t: Pick<TableSummary, "caption">): string => t.caption.trim() || "Untitled table";

/** "1 paper you can't see", "2 papers you can't see". */
export function unseenPapers(n: number): string {
  return `${n} paper${n === 1 ? "" : "s"} you can't see`;
}
